var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 398,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("circle", {
    id: "svg_1",
    r: 9.92,
    cy: 129.95,
    cx: 134.14,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m100.07,178.04q2.89,0.25 5.03,-1.34q3.59,-2.66 7.32,-3.95q0.28,-0.1 0.46,-0.33q0.09,-0.12 0.2,-0.2q0.08,-0.07 0.18,-0.09q2.97,-0.86 6.1,-1.47q0.24,-0.05 0.43,-0.21q0.1,-0.09 0.19,-0.19a0.58,0.53 15.1 0 1 0.33,-0.17q13.59,-2.06 26.25,3.57q1.61,0.72 2.97,1.7c1.26,0.9 2.75,1.57 3.92,2.47q10.48,8.07 15.58,19.24q7.23,15.82 4.45,33.14q-1.73,10.77 -7.4,19.67c-11.74,18.44 -34.6,27.34 -55.59,20.81c-3.77,-1.18 -7.53,-2.5 -10.9,-4.6c-11.86,-7.35 -20.18,-18.54 -23.55,-32.05q-1.54,-6.14 -1.46,-17.1q0.23,-32.27 -0.01,-66.79q-0.02,-3 0.34,-6.01q0.55,-4.42 4.83,-7.82q1.26,-1 2.74,-1.37c1.58,-0.4 2.84,-1.27 4.52,-1.22q6.14,0.18 11.59,0.01q1.01,-0.03 1,0.98l-0.05,42.74q0,0.53 0.53,0.58zm24.1159,71.1285a28.26,25.69 89.4 0 0 25.3927,-28.5275a28.26,25.69 89.4 0 0 -25.9845,-27.9895a28.26,25.69 89.4 0 0 -25.3927,28.5275a28.26,25.69 89.4 0 0 25.9845,27.9895z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m212.46,271.21q-1.49,1.23 -3.82,1.39q-7.1,0.49 -14.31,0a0.49,0.48 -88.1 0 1 -0.45,-0.49q-0.11,-60.33 -0.04,-124.77c0.01,-5.7 2.36,-9.76 7.47,-12.32a1.76,1.65 -81.5 0 0 0.57,-0.45q0.63,-0.75 1.61,-0.75q7.23,0 14.56,-0.04a0.95,0.95 0 0 1 0.95,0.95q-0.01,63.42 0.02,124.2q0,6.44 -3.95,10.53c-0.84,0.86 -1.73,1.02 -2.61,1.75z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    d: "m277.13,248.81q5.49,0.75 7.64,0.21q9.61,-2.41 12.93,-10.27q1.78,-4.2 1.69,-12.3q-0.27,-22.68 0.01,-42.74c0.09,-6.87 5.5,-12.1 12.37,-12.14q6.32,-0.04 12.03,0.12a0.48,0.48 0 0 1 0.47,0.48q-0.04,27.85 -0.02,57.79q0.01,11.82 -5.83,21.65q-7.92,13.34 -22.33,18.56q-14.59,5.29 -28.92,0.15q-15.41,-5.53 -23.52,-20.21q-4.94,-8.93 -4.95,-20.06q-0.02,-29.2 -0.03,-57.83a0.53,0.53 0 0 1 0.51,-0.53q5.92,-0.2 11.83,-0.2c7.29,0 12.6,5.72 12.61,12.94q0.02,23.61 0.05,46.77q0.01,9.71 8.56,15.61c0.99,0.68 2.58,0.81 3.52,1.46q0.64,0.45 1.38,0.54z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlu);
export default __webpack_public_path__ + "static/media/Blu.842d36eb33359a29bf9165df82cd791d.svg";
export { ForwardRef as ReactComponent };